import React, {useCallback} from 'react';

import {useLicenseTypes} from 'src/hooks/dictionaries';

import {FlatButton} from '@pb/kit-component-button';
import CheckBoxTree from '@pb/kit-component-checkbox-tree';
import {Group} from '@pb/kit-component-group';
import {Scroll} from '@pb/kit-component-scroll';

import type {ChangeTreeType} from '@pb/kit-component-checkbox-tree';


type Props = {
    selectedLicenseTypes?: string[],
    onChange: (licenseTypes: string[]) => void,
};

export const LicenseTypeFilter = ({selectedLicenseTypes, onChange}: Props) => {
    const {licenseTypes} = useLicenseTypes();

    const changeLicenseType = useCallback((types: ChangeTreeType) => {
        const checkedTypes = [...types.checkedIdsList];

        if (selectedLicenseTypes) {
            const diff = checkedTypes.filter(type => !selectedLicenseTypes.includes(type));

            if (diff.includes('blank')) {
                onChange(['blank']);
            } else if (selectedLicenseTypes.includes('blank')) {
                onChange(checkedTypes.filter(type => type !== 'blank'));
            } else {
                onChange(checkedTypes);
            }
        } else {
            onChange(checkedTypes);
        }
    }, [selectedLicenseTypes, onChange]);

    const selectAll = useCallback(() => {
        onChange(licenseTypes.map(({code}) => code));
    }, [licenseTypes, onChange]);

    const deselectAll = useCallback(() => {
        onChange([]);
    }, [onChange]);

    return (
        <Group direction="v" alignItems="start">
            <FlatButton onClick={selectedLicenseTypes?.length ? deselectAll : selectAll}>
                {selectedLicenseTypes?.length ? 'Deselect All' : 'Select All'}
            </FlatButton>
            <Scroll>
                <div style={{height: 260}}>
                    <div style={{width: 270}}>
                        <CheckBoxTree
                            checkedIdsList={selectedLicenseTypes || []}
                            data={
                                [
                                    {code: 'blank', description: '(Blank)'},
                                    ...licenseTypes,
                                ].map(({code, description}) => ({
                                    id: code,
                                    caption: description,
                                }))
                            }
                            onChange={changeLicenseType}
                        />
                    </div>
                </div>
            </Scroll>
        </Group>
    );
};
